<template>
 <div class="jobsDetail">
    <div class="navBar"><van-icon name="cross" @click="back()"/><span class="title">{{title}}</span></div>
    <van-tabs v-model="activeName">
      <van-tab title="职位详情" name="a">
        <div class="list-item">
             <div class="job-title">{{detailObj.positionName}}</div>
             <div class="job-companey">{{detailObj.companyName}}</div>
             <div class="job-dec">发布时间：{{detailObj.publishTime}}</div>
             <div class="job-tags">
                 <span v-if="detailObj.education!=null">{{edList[detailObj.education]}}</span>
                 <span v-if="detailObj.experience!=null">{{exList[detailObj.experience]}}</span>
                 <span v-if="detailObj.positionType">{{ptList[detailObj.positionType]}}</span>
             </div>
             <div class="job-salary" v-if="detailObj.salaryEndNum<=2&&(detailObj.salaryStartNum==null||detailObj.salaryStartNum<=2)">2k以下</div>
             <div class="job-salary" v-else-if="detailObj.salaryStartNum>=50">50k以上</div>
             <div class="job-salary" v-else>{{detailObj.salaryStartNum?detailObj.salaryStartNum+'-':''}}{{detailObj.salaryEndNum?detailObj.salaryEndNum:''}}k</div>
         </div>
         <!-- <div class="list-item">
           <div class="job-title">岗位职责</div>
           <div class="item-content">
              1、参与公司产品的需求分析与架构设计；<br>
              2、根据产品需求，完成功能模块的开发；<br>
              3、负责产品代码的开发与维护，按计划完成开发工作；<br>
              4、配合客户端工程师和测试工程师完成开发工作。
           </div>
         </div>
          <div class="list-item">
           <div class="job-title">岗位要求</div>
           <div class="item-content">
              1、本科及以上学历，3年以上JAVA开发经验，有大型互联网产品开发经验者优先；<br>
              2、熟悉SpringMVC、SpringBoot，了解Java底层原理优先考虑；<br>
              3、熟悉Java虚拟机调优，熟悉Java虚拟机内存管理原理，精通常用的缓存技术，如memcache、redis、mongo等；<br>
              4、熟悉常用的设计模式，具备优秀的技术架构的设计能力，具有高并发高可用服务接口设计开发经验；<br>
              5、具有较强的新知识学习能力和错误调试排错能力，能独立承担任务和有系统进度把控能力，热爱技术、做事追求完美的技术达人优先考虑。
           </div>
         </div> -->
          <div class="list-item">
           <div class="job-title">职位介绍</div>
           <div class="item-content">
              {{detailObj.positionDesc?detailObj.positionDesc:'暂无'}}
           </div>
         </div>
         <div class="list-item">
           <div class="job-title">福利待遇</div>
           <div class="item-content">
              {{detailObj.workBenefits}}
           </div>
         </div>
      </van-tab>
      <van-tab title="公司详情" name="b">
        <!-- <div class="list-item">
           <div class="job-title">公司名称</div>
           <div class="item-content">
              {{companyDetail.name}}
           </div>
         </div> -->
        <div class="list-item">
           <div class="job-title">公司简介</div>
           <div class="item-content">
              {{companyDetail.intro?companyDetail.intro:'暂无'}}
           </div>
         </div>
         <div class="list-item">
           <div class="job-title">本公司基本信息</div>
           <div class="item-content">
              公司地址：{{companyDetail.addressProvince=='北京市'||companyDetail.addressProvince=='上海市'||companyDetail.addressProvince=='天津市'||companyDetail.addressProvince=='重庆市'?'':companyDetail.addressProvince}}{{companyDetail.addressCity}}{{companyDetail.addressInfo}}<br>
              联系电话：{{companyDetail.linkman.landlinePhone?companyDetail.linkman.landlinePhone:companyDetail.linkman.mobilePhone}}
           </div>
         </div>
         <div class="more-title">本公司招聘其他岗位</div>
         <div v-if="Object.keys(otherList).length>0">
           <div class="list-item" v-for="item in otherList" :key="item.id" @click="toDetail(item.id)">
            <div class="job-title fs28">{{item.positionName}}</div>
              <div class="job-companey">{{item.companyName}}</div>
              <div class="job-dec">发布时间：{{item.publishTime}}</div>
              <div class="job-tags">
                  <span v-if="item.education!=null">{{edList[item.education]}}</span>
                  <span v-if="item.experience!=null">{{exList[item.experience]}}</span>
                  <span v-if="item.positionType">{{ptList[item.positionType]}}</span>
              </div>
              <div class="job-salary" v-if="item.salaryEndNum<=2&&(item.salaryStartNum==null||item.salaryStartNum<=2)">2k以下</div>
              <div class="job-salary" v-else-if="item.salaryStartNum>=50">50k以上</div>
              <div class="job-salary" v-else>{{item.salaryStartNum?item.salaryStartNum+'-':''}}{{item.salaryEndNum?item.salaryEndNum:''}}k</div>
            </div>
         </div>
         <div v-else class="no-more">暂无其他招聘岗位</div>
      </van-tab>
    </van-tabs>
    <!-- <div class="fixed-btn">
      <span>投个简历</span>
    </div> -->
 </div>
</template>

<script>
import { Toast } from 'vant';
import $ from "jquery";
export default {
    name: "jobsDetail",
    components: {
        // courseItem
    },
    data () {
        return {
            title:'招聘详情',
            activeName:'a',
            id:parseInt(this.$route.query.id),
            companyDetail:{
              linkman:{
                landlinePhone:''
              }
            },
            detailObj:{},
            otherList:[],
            edList:['不限','高中','大专','本科','研究生','博士'],
            exList:['不限','应届毕业生','3年以下','3-5年','5年以上'],
            ptList:['','全职','兼职','合伙人'],
        };
    },
    computed: {
     
    },


    created(){
    },

    mounted(){
      //获取职位信息
      this.getjobsDetail();
       if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.back, false); //false阻止默认事件
        }
    },
    destroyed(){
        window.removeEventListener("popstate", this.back, false); //false阻止默认事件
    },

    methods: {
      //返回
      back(){
        this.$router.push('/jobsList');
      },
      //其他职位跳转
      toDetail(id){
        if(this.id != id){
          this.$router.push({
                path: '/jobsDetail',
                query: {
                    id: id
                }
            });
        }
        $(window).scrollTop(0)
        this.id = id;
        this.activeName = 'a';
        this.getjobsDetail();
      },
      //获取公司信息
      getCompanyInfoWithoutMan(){
        this.$api.jobsDetail.companyInfoWithoutMan(
          {
            companyId: this.detailObj.companyId,
          }
        )
        .then(res=>{
            if(res.code===0){
              this.companyDetail = res.data;
              // console.log(res.data)
            }else{
              console.log(res.message)
            }
        })
      },
      //获取招聘基本信息  
      getjobsDetail(){
        this.$api.jobsDetail.findById(
          {
            id: this.id,
          }
        )
        .then(res=>{
            // console.log(res);
            if(res.code===0){
              this.detailObj = res.data;
              this.getCompanyInfoWithoutMan();
              this.findSimilarPostion();
            }else{
              console.log(res.message)
            }
        })
      },
      //获取其他职位列表
      findSimilarPostion(){
        this.$api.jobsDetail.findSimilarPostion(
          {
            companyId:this.detailObj.companyId,
            id:this.id
          }
        )
        .then(res=>{
            if(res.code===0){
              this.otherList = res.data.list;
            }else{
              console.log(res.message)
            }
        })
      }
    },
}

</script>


<style scoped>
 @import "../asset/css/jobsDetail.css"
</style>
